import { EventEmitter } from 'eventemitter3';
export class EventBus {
    _eventEmitter;
    _logger;
    constructor({ logger } = {}) {
        this._eventEmitter = new EventEmitter();
        this._logger = logger;
    }
    addListener(eventName, callback, { once } = {}) {
        if (once === true) {
            this._eventEmitter.once(eventName, callback);
        }
        else {
            this._eventEmitter.addListener(eventName, callback);
        }
    }
    removeListener(eventName, callback, { once } = {}) {
        this._eventEmitter.removeListener(eventName, callback, once);
    }
    dispatch(eventName, data) {
        this._logger.debug(`[shell] - Dispatching event "${String(eventName)}"`, data);
        this._eventEmitter.emit(eventName, data);
    }
}
